import { DatePicker as UiDatepicker } from "@rumbledirect/ui";
import dayjs, { Dayjs } from "dayjs";
import { Question } from "survey-core";

export class DatePickerQuestionModel extends Question {
  getType() {
    return "datepicker";
  }
}

interface DatePickerQuestionProps {
  question: DatePickerQuestionModel;
}

export const DatePickerQuestion = (props: DatePickerQuestionProps) => {
  const handleChange = (value: Dayjs | Dayjs[] | null) => {
    if (!value || Array.isArray(value) || !value.isValid()) {
      props.question.value = undefined;
    } else {
      props.question.value = value.toISOString();
    }
  };

  const value = props.question.value ? dayjs(props.question.value) : null;

  return (
    <UiDatepicker
      styles={{
        root: { fontWeight: 500, width: "100%" },
        popup: {
          container: { maxWidth: "85vw" },
          header: { maxWidth: "85vw" },
          body: { maxWidth: "85vw" },
          footer: { maxWidth: "85vw" },
        },
      }}
      id={props.question.inputId}
      disabled={props.question.isDisabledAttr}
      readOnly={props.question.isReadOnlyAttr}
      value={value}
      placeholder=""
      inputReadOnly
      style={props.question.inputStyle}
      onBlur={(e) => props.question.onBlur(e)}
      onFocus={(e) => props.question.onFocus(e)}
      onChange={handleChange}
      needConfirm={false}
      showTime={props.question.showTime ? { format: "HH:mm" } : false}
      format={props.question.showTime ? "DD-MM-YYYY HH:mm" : "DD-MM-YYYY"}
      onClick={props.question.readOnlyBlocker}
      onPointerDown={props.question.readOnlyBlocker}
      aria-required={props.question.a11y_input_ariaRequired}
      aria-label={props.question.a11y_input_ariaLabel}
      aria-labelledby={props.question.a11y_input_ariaLabelledBy}
      aria-describedby={props.question.a11y_input_ariaDescribedBy}
      aria-invalid={props.question.a11y_input_ariaInvalid}
      aria-errormessage={props.question.a11y_input_ariaErrormessage}
      disableFuture
    />
  );
};
